export default "__VITE_ASSET__DN_Q1xY9__"